// eslint-disable-next-line @typescript-eslint/no-var-requires
const marked = require('marked');

export const getHTMLFromMarkdown = (
  markdown: string,
  markedOptions?: marked.MarkedOptions,
) => {
  const options = markedOptions || {};

  try {
    marked.setOptions(options);

    const removedBackslashes = markdown
      .replace(/\\_/g, '_')
      .replace(/\\-/g, '-');

    return marked(removedBackslashes);
  } catch (error) {
    return markdown;
  }
};
